/**
 * debug.js — see what Daily Ops costs in Firestore, live, on any device.
 *
 * Turn on in the browser console:   localStorage.do_debug = '1'   (then reload)
 * Turn off:                          localStorage.removeItem('do_debug')
 *
 * Every listener open / snapshot / close and every one-shot fetch is logged with its
 * document count, e.g. `[daily-ops] listen items:live:2026-10-15 → 161 docs (server)`.
 * A snapshot that comes from the server after a reconnect is what Firestore bills;
 * one served from the cache is free. Off by default — production stays quiet.
 */
import { DEBUG_LS_KEY } from '../config/constants';

let enabled = null;
export function debugOn() {
  if (enabled === null) {
    try { enabled = typeof localStorage !== 'undefined' && localStorage.getItem(DEBUG_LS_KEY) === '1'; } catch { enabled = false; }
  }
  return enabled;
}

/** `[daily-ops] <what> <key> → <n> docs (<source>)` when debugging is on. */
export function debugLog(what, key, detail = '') {
  if (!debugOn()) return;
  // eslint-disable-next-line no-console
  console.info(`[daily-ops] ${what} ${key}${detail ? ` → ${detail}` : ''}`);
}

/** Describe a snapshot for debugLog: size, how many docs changed, cache or server. */
export const snapInfo = snap => {
  const changed = typeof snap.docChanges === 'function' ? snap.docChanges().length : snap.size;
  return `${snap.size} docs, ${changed} changed (${snap.metadata && snap.metadata.fromCache ? 'cache' : 'server'})`;
};

/** Test helper: forget the cached on/off flag. */
export const resetDebug = () => { enabled = null; };
